export default __webpack_public_path__ + "static/media/finance3.fc907095.svg";